import React, { MutableRefObject } from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'
import css from 'styled-jsx/css'

import { addClass } from '~/common/utils/html'
import { GeneralIconTag } from '~/common/define/icon'
import { ColorWeight, lightenColor, SpaceColor } from '~/common/define/color'
import InternalLink from '~/components/atoms/link/InternalLink'
import Icon, { IconSize } from '~/components/atoms/icon/Icon'

interface Props {
  text: string
  iconTag: GeneralIconTag
  link: string
  color: SpaceColor
  linkRef?: MutableRefObject<any>
}

const NavigationLinkRow = ({text, iconTag, link, color, linkRef = null}: Props) => {
  const {className: colorClass, styles: colorStyles} = css.resolve`
    a:hover { background: ${lightenColor(color, ColorWeight.LIGHT)}; }
    a:active { background: ${lightenColor(color, ColorWeight.WELTER)}; }
  `

  return (
    <InternalLink link={link} className={styles.linkRow + addClass(colorClass)} anchorRef={linkRef}>
      <Icon tag={iconTag} size={IconSize.SMALL} fillColor={color}/>
      <p>{text}</p>
      <style jsx>{`
        p {
          color: ${color};
        }
     `}</style>
      {colorStyles}
    </InternalLink>
  )
}

export default NavigationLinkRow